import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { ExternalReferralRow } from "@/lib/database.types";

export function useReferral(patientId: string | undefined) {
  return useQuery<ExternalReferralRow | null>({
    queryKey: ["referral", patientId],
    enabled: !!patientId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("external_referrals")
        .select("*")
        .eq("patient_id", patientId!)
        .order("updated_at", { ascending: false })
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      return (data as ExternalReferralRow | null) ?? null;
    },
  });
}
